import Cookies from "js-cookie";
import storeAsSecureCookie from "manifest-components/src/utils/storeAsSecureCookie";
import { ACCESS_TOKEN, CURRENT_TRANSFER_ID, LOGGED_IN, USER_ID, VENDOR_NAME, USER_IDENTITY_ID } from "../constants";

export const CookiePaths = {
  ACCESS_TOKEN,
  USER_ID,
  USER_IDENTITY_ID,
};

const clearAllCookies = () => Object.values(CookiePaths).forEach((path) => Cookies.remove(path));

const Session = {
  clearSession() {
    window.sessionStorage.clear();
    clearAllCookies();
  },

  // The access token should be stored in a cookie with the same site attribute set to LAX
  // See: https://blog.logrocket.com/jwt-authentication-best-practices/
  get accessToken() {
    return Cookies.get(CookiePaths.ACCESS_TOKEN) || "";
  },
  set accessToken(val: string) {
    storeAsSecureCookie(CookiePaths.ACCESS_TOKEN, val);
  },
  get vendorName() {
    return window.sessionStorage.getItem(VENDOR_NAME) || "";
  },
  set vendorName(val: string) {
    window.sessionStorage.setItem(VENDOR_NAME, val);
  },

  get userId() {
    return Cookies.get(CookiePaths.USER_ID) || "";
  },
  set userId(val: string) {
    storeAsSecureCookie(CookiePaths.USER_ID, val);
  },
  set userIdentityId(val: string) {
    storeAsSecureCookie(CookiePaths.USER_IDENTITY_ID, val);
  },
  get userIdentityId() {
    return Cookies.get(CookiePaths.USER_IDENTITY_ID) || "";
  },

  // This value is also used for cleaning up any cookies on startup when the user is not logged in.
  get loggedIn() {
    return window.sessionStorage.getItem(LOGGED_IN) === "true";
  },
  set loggedIn(val: boolean) {
    window.sessionStorage.setItem(LOGGED_IN, `${val}`);
  },

  get currentTransferId() {
    return window.sessionStorage.getItem(CURRENT_TRANSFER_ID) || "";
  },
  set currentTransferId(val: string) {
    window.sessionStorage.setItem(CURRENT_TRANSFER_ID, val);
  },

  get adminUsername() {
    return window.localStorage.getItem("adminUserName") || "";
  },
  set adminUsername(val: string) {
    window.localStorage.setItem("adminUserName", val);
  },

  get adminPassword() {
    return window.localStorage.getItem("adminPassword") || "";
  },
  set adminPassword(val: string) {
    window.localStorage.setItem("adminPassword", val);
  },
};

export const clearCookiesOnStartup = () => {
  if (!Session.loggedIn) {
    Session.clearSession();
  }
};

export const migrateStorageToCookies = () => {
  if (window.sessionStorage.getItem(ACCESS_TOKEN)) {
    Session.accessToken = window.sessionStorage.getItem(ACCESS_TOKEN) || "";
    window.sessionStorage.removeItem(ACCESS_TOKEN);
  }
  if (window.sessionStorage.getItem(USER_ID)) {
    Session.userId = window.sessionStorage.getItem(USER_ID) || "";
    window.sessionStorage.removeItem(USER_ID);
  }
};

export default Session;
